export default __webpack_public_path__ + "static/media/accountlinksuccess.45179f60.svg";